import GoogleTagManagerScript from 'app/components/scripts/GoogleTagManagerScript';
import MedalliaScript from 'app/components/scripts/MedalliaScript';
import PendoScript from 'app/components/scripts/PendoScript';

// TODO DEVIN-1702: Add Google Tag Manager noscript w/ 'afterInteractive' strategy because it is located in the <body>.

// Convenience component that includes all third-party scripts
export const ThirdPartyScripts = () => {
  return (
    <>
      <GoogleTagManagerScript />
      <MedalliaScript />
      <PendoScript />
    </>
  );
};
